import styled from 'styled-components';
import * as PopoverPrimitive from '@radix-ui/react-popover';

export const PopoverPrimitiveContent = styled(PopoverPrimitive.Content)`
  background-color: ${props => props.theme.colors.card};
  border-radius: 10px;
  
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

  border: solid 1px;
  border-color: rgba(0, 0, 0, 0.1);

  z-index: 100;
`;
